import QuickStartGuidePage from '@/docs-partials/api/quick-start-guide.mdx';
import * as React from 'react';
export default {
  QuickStartGuidePage,
  React
};